import { create } from 'zustand';

export type EgressFeature = 'recording' | 'ndi' | 'rtmp';

const key = (deviceId: string, feature: EgressFeature) => `${deviceId}:${feature}`;

interface Store {
  /** key `${deviceId}:${feature}` → the error text the operator dismissed. */
  dismissed: Record<string, string>;
  dismiss: (deviceId: string, feature: EgressFeature, error: string) => void;
  clear: (deviceId: string, feature: EgressFeature) => void;
  isDismissed: (deviceId: string, feature: EgressFeature, error: string | undefined) => boolean;
}

// Renderer-local: keyed by error text so a different failure reappears on its own.
export const useEgressErrorStore = create<Store>()((set, get) => ({
  dismissed: {},
  dismiss: (deviceId, feature, error) =>
    set((state) => ({ dismissed: { ...state.dismissed, [key(deviceId, feature)]: error } })),
  clear: (deviceId, feature) =>
    set((state) => {
      const next = { ...state.dismissed };
      delete next[key(deviceId, feature)];
      return { dismissed: next };
    }),
  isDismissed: (deviceId, feature, error) => {
    if (error === undefined) return false;
    return get().dismissed[key(deviceId, feature)] === error;
  }
}));
